import store from '@/store'

export default (to, from, next) => ({
    allow: store.getters.is_auth,
    redirect: { name: 'sign-in' },
});
